import operativeContextRoles from './operativeContextRoles.js';

export default {
  mixins: [operativeContextRoles],
  props: {
    company: {
      type: Object,
    },
  },
  computed: {
    isWhatif () {
      const forecast = JSON.parse(this.$localStorage.get('forecast', '{}'));

      return !!(forecast?.id || false);
    },
    userCanEdit () {
      return this.userIsAdmin || this.userIsContextCompanyConsultant || this.userIsContextCompanyOwner || (this.isWhatif && this.userIsContextCompanyManager);
    },
  },
};
